import React from 'react';
import { orderTicketTitle, orderSessionLabel } from './orderDisplay';
import SessionBadge from '../SessionBadge';

/** Nom du billet + badge jour / validité pour une commande. */
export default function OrderTicketDisplay({
    order,
    className = '',
    titleClassName = 'text-gray-800 dark:text-gray-100 c1k3n text-xs',
    showBadge = true,
    layout = 'stack',
}) {
    const title = orderTicketTitle(order);
    const hasSession = Boolean(orderSessionLabel(order));

    if (layout === 'inline') {
        return (
            <div className={`flex flex-wrap items-center gap-1.5 ${className}`}>
                <span className={titleClassName}>{title}</span>
                {showBadge && hasSession && <SessionBadge order={order} />}
            </div>
        );
    }

    return (
        <div className={className}>
            <div className={titleClassName}>{title}</div>
            {showBadge && hasSession && (
                <div className="mt-0.5">
                    <SessionBadge order={order} />
                </div>
            )}
        </div>
    );
}
